import React from 'react'
import "./events.css"
import Event from "./Event"
import cal from "./cal.png"
const Events = () => {
  return (
    <div className="event_outer">
        <img src = {cal} alt = "img" />
    </div>
  )
}

export default Events